import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { CarBrand } from "../../types/modules/admin/carBrand.type";

export const useCarBrandsByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["car-brands-by-admin"],
    queryFn: () => fetcher<CarBrand[]>(`car-brand/admin`, token),
  });
};
